import React from 'react';

import PropTypes from 'prop-types';

import StatusView from '@vfgroup-oneplatform/foundation/Components/StatusView';

import styles from './Loading.style';

const Loading = ({ subTitle }) => {
  return (
    <StatusView
      lottieProps={{
        type: 'spinner',
        autoPlay: true,
        loop: true,
        lottieViewStyle: styles.lottieViewStyle,
      }}
      description={subTitle}
      containerStyle={styles.loadingViewContainer}
      textStyles={{ description: styles.loadingDescription }}
    />
  );
};

Loading.propTypes = {
  subTitle: PropTypes.string.isRequired,
};

export default Loading;
